import { render, staticRenderFns } from "./RegularButton.vue?vue&type=template&id=35eb4dec&scoped=true"
import script from "./RegularButton.vue?vue&type=script&lang=js"
export * from "./RegularButton.vue?vue&type=script&lang=js"
import style0 from "./RegularButton.vue?vue&type=style&index=0&id=35eb4dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb4dec",
  null
  
)

export default component.exports